<template>
    <div>
        Admin Dashboard
        <button class="btn btn-default">Test Button</button>
    </div>
</template>

<script>
export default {
    name: "AdminDashboard",
    mounted() {
        this.$root.$emit("admin_left_panel_update", null);
    }
}
</script>